import {Injectable} from '@angular/core';

@Injectable()
export class UrlService {

    private domain = '';

    constructor() {
        this.domain = window.location.protocol + '//' + window.location.host;
        this.domain = this.domain.replace(":4200", ":3000");
    }

    /**
     * This build URL from current domain.
     **/
    public build(url): string {

        if (url.substr(0, 1) !== '/') {
            url = '/' + url;
        }

        return `${this.domain}${url}`;
    }

}


// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/services/url.service.ts